import { useMutation } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import {
  sendPushNotification,
  SendPushInput,
} from "../services/send-push-notification";

export function useSendPushNotification() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: (input: SendPushInput) => sendPushNotification(input),
    onSuccess: () => {
      toast({
        title: "Push sent",
        description: "Notification dispatched to the user.",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to send push notification",
        variant: "destructive",
      });
    },
  });
}
